var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('el-dialog', {
    attrs: {
      "title": "Finish Review",
      "close-on-click-modal": false,
      "visible": _vm.visible,
      "width": "800px",
      "top": "3vh"
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.visible = $event;
      }
    }
  }, [_c('el-form', {
    ref: "dataForm",
    attrs: {
      "model": _vm.dataForm,
      "autocomplete": "off",
      "label-width": "110px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Status",
      "prop": "applymentStatus"
    }
  }, [_c('el-radio-group', {
    model: {
      value: _vm.dataForm.applymentStatus,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "applymentStatus", $$v);
      },
      expression: "dataForm.applymentStatus"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "QUOTATION_AUDIT_FAIL"
    }
  }, [_vm._v("Rejected")]), _c('el-radio', {
    attrs: {
      "label": "QUOTATION_AUDIT_PASS"
    }
  }, [_vm._v("Pass")])], 1)], 1), _c('el-form-item', {
    attrs: {
      "label": "Remark",
      "prop": "remark"
    }
  }, [_c('el-input', {
    directives: [{
      name: "regexFilter",
      rawName: "v-regexFilter",
      value: _vm.halfWidthRegex,
      expression: "halfWidthRegex"
    }],
    attrs: {
      "type": "textarea",
      "rows": 5,
      "autosize": {
        minRows: 4
      },
      "resize": "none",
      "placeholder": "Remark"
    },
    model: {
      value: _vm.dataForm.remark,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "remark", $$v);
      },
      expression: "dataForm.remark"
    }
  })], 1), _c('el-form-item', {
    attrs: {
      "label": "attachments",
      "prop": "attachmentUrls"
    }
  }, [_c('el-multiple-file-uploader', {
    model: {
      value: _vm.dataForm.attachmentUrls,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "attachmentUrls", $$v);
      },
      expression: "dataForm.attachmentUrls"
    }
  })], 1)], 1), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function click($event) {
        _vm.visible = false;
      }
    }
  }, [_vm._v("Cancel")]), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.submitLoading
    },
    on: {
      "click": _vm.dataFormSubmit
    }
  }, [_vm._v("OK")])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }